import { feedInit } from './instafeed';
import themeEditor from './themeEditor';

const Instagram = () => {
  if (document.querySelectorAll('[data-section-type="INF-Instagram"]').length === 0) {
    return;
  }

  // Initialize all feeds on page load and add them to the index
  document.querySelectorAll('.Instafeed').forEach((feed) => {
    const sectionId = feed.closest('section').dataset.sectionId;
    feedInit(sectionId, feed);
  });

  themeEditor();
};

export { Instagram };
